import React, { Component } from 'react';
import PropTypes from 'prop-types'; 
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  Typography,
} from '@material-ui/core';

import '../../assets/stylesheets/CircularProgressButton.css';

class CircularProgressButton extends Component {
  render() {
    const {
      buttonText,
      buttonOnClick,
      loading,
      progress,
      tooltipText,
    } = this.props;

    return (
      <>
        <Box className='cpbContainer'>
          <Box className='cpbWrapper'>
            <Tooltip title={<Typography>{tooltipText}</Typography>}>
              <span>
                <Button
                  className="ssenseButton ssensePrimary"
                  variant="contained"
                  disabled={loading}
                  onClick={buttonOnClick}
                >
                  {buttonText}
                </Button>
              </span>
            </Tooltip>
            {loading && (
              <>
                <CircularProgress
                  variant={progress !== 0 ? 'determinate' : 'indeterminate'}
                  value={progress}
                  size={34}
                  color='inherit'
                  className='cpbSpinner'
                />

                <Box className='cpbProgressContainer'>
                  <Typography variant="caption" component="div" color='inherit'>
                    {progress !== 0 ? `${progress}%` : ''}
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </>
    )
  }
}

CircularProgressButton.defaultProps = {
  progress: 0,
}

CircularProgressButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  progress: PropTypes.number,
  tooltipText: PropTypes.string.isRequired,
};

export default CircularProgressButton;
